/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Indicates that the investigation test has been started.
 */
export enum InvestigationTestStatus {
    UNDEFINED = 'undefined',
    NEW = 'new',
    STARTED = 'started',
    SUBMITTED_TO_VALIDATION = 'submittedToValidation',
    REJECTED = 'rejected',
    APPROVED = 'approved',
}
